export function getInputValueAfterKeydown(
  e: KeyboardEvent | React.KeyboardEvent<HTMLInputElement>,
) {
  if (!(e.target instanceof HTMLInputElement)) return "";

  const { selectionStart, selectionEnd, value } = e.target;

  if (selectionStart === null || selectionEnd === null) return value;

  if (e.code === "Backspace") {
    return selectionStart === selectionEnd || selectionStart === 0
      ? `${value.substring(0, selectionStart)}${value.substring(selectionEnd)}`
      : `${value.substring(0, selectionStart - 1)}${value.substring(selectionEnd)}`;
  }

  if (e.code === "Delete") {
    return selectionStart === selectionEnd || selectionEnd === value.length
      ? `${value.substring(0, selectionStart)}${value.substring(selectionEnd)}`
      : `${value.substring(0, selectionStart)}${value.substring(selectionEnd + 1)}`;
  }

  if (!isSymbolKey(e)) return value;

  return `${value.substring(0, selectionStart)}${e.key}${value.substring(selectionEnd)}`;
}

export function isSymbolKey(e: KeyboardEvent | React.KeyboardEvent<HTMLInputElement>) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
